module.exports = __webpack_public_path__ + "static/media/primemodalnvcompra.858e31ba.png";